import { VALIDATION_ERROR_KEYS } from "@/i18n"
import { addressDetailsSchema } from "@/lib/zod-schemas/address-schema"
import {
  boolean,
  optionalString,
  requiredString,
} from "@/lib/zod-schemas/literals"
import * as z from "zod"

export const reliefListingSchema = z
  .object({
    invite_only: boolean,
    details: z.object({
      title: requiredString,
      description: optionalString,
      subject_key: requiredString,
      delivery_mode: z
        .array(z.enum(["online", "in_person"]), VALIDATION_ERROR_KEYS.REQUIRED)
        .nonempty(VALIDATION_ERROR_KEYS.REQUIRED),
      address: addressDetailsSchema.nullable(),
      start_date: z.iso.date(VALIDATION_ERROR_KEYS.REQUIRED),
      end_date: z.iso.date(VALIDATION_ERROR_KEYS.REQUIRED),
      contact_details: z.object({
        name: requiredString,
        email: z
          .email(VALIDATION_ERROR_KEYS.MUST_BE_VALID_EMAIL)
          .min(1, VALIDATION_ERROR_KEYS.REQUIRED),
      }),
      tag_ids: z.array(z.string()),
      timetable: z.object({
        timezone_id: requiredString,
        sessions: z
          .array(
            z.object({
              day: z.enum(
                [
                  "monday",
                  "tuesday",
                  "wednesday",
                  "thursday",
                  "friday",
                  "saturday",
                  "sunday",
                ],
                VALIDATION_ERROR_KEYS.REQUIRED,
              ),
              week: z.enum(
                ["week_one", "week_two"],
                VALIDATION_ERROR_KEYS.REQUIRED,
              ),
              start_time: z.iso.time(),
              end_time: z.iso.time(),
            }),
          )
          .nonempty(VALIDATION_ERROR_KEYS.REQUIRED),
      }),
    }),
  })
  .refine(
    (data) => {
      if (!data.details.delivery_mode.includes("in_person")) {
        return true
      }
      return data.details.address
    },
    {
      message: VALIDATION_ERROR_KEYS.REQUIRED,
      path: ["details.address"],
    },
  )
